/* LensAdvisor bundle grouping: keep lens/add-on lines in sync with their frame.
   Rows are tagged in snippets/cart-item.liquid with data-la-uid (shared bundle
   id) and data-la-type (frame / lens / addon). The theme's cart-form batches
   every .cart-item__quantity-input value into one cart update, so syncing the
   hidden inputs before that batch fires is enough to remove or requantify the
   whole bundle together. These document-level listeners run after cart-form's
   own delegate handlers have set the frame input's new value. */

const laBundleSyncFromFrame = (frameItem) => {
  const frameInput = frameItem.querySelector('.cart-item__quantity-input');
  const uid = frameItem.dataset.laUid;
  if (!frameInput || !uid) return;

  document.querySelectorAll('.cart-item[data-la-uid]').forEach((peer) => {
    if (peer === frameItem || peer.dataset.laUid !== uid || peer.dataset.laType === 'frame') return;
    const peerInput = peer.querySelector('.cart-item__quantity-input');
    if (peerInput) peerInput.value = frameInput.value;
  });
};

document.addEventListener('click', (evt) => {
  const control = evt.target.closest('.cart-item__remove, .quantity-down, .quantity-up');
  if (!control) return;
  const cartItem = control.closest('.cart-item');
  if (cartItem && cartItem.dataset.laType === 'frame') laBundleSyncFromFrame(cartItem);
});

document.addEventListener('change', (evt) => {
  if (!evt.target.matches('.cart-item__quantity-input')) return;
  const cartItem = evt.target.closest('.cart-item');
  if (cartItem && cartItem.dataset.laType === 'frame') laBundleSyncFromFrame(cartItem);
});
